import { mapValues, isPlainObject, isFunction } from 'lodash'

export const bindObjectFunctions = (obj: any, ...args: any[]): any => {
  return mapValues(obj, val => {
    if (isFunction(val)) {
      return val.bind(obj, ...args)
    } else if (isPlainObject(val)) {
      return bindObjectFunctions(val, ...args)
    }

    return val
  })
}
